import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  skeletonWebsiteText: {
    maxWidth: '50px',
    maxHeight: 7,
    height: 7,
    margin: 0,
    marginBottom: 3
  }
})

export default useStyles
